import React from "react";
import styles from "./list.module.scss";
import Checkbox from "../../../../checkbox";
import QrGenerator from "../../../../containers/qrCode";
import moment from "moment";
import Loading from "../../../../loading";
import getDaysLeft from "../../../../../_utils/getDaysLeft";
import t from "../../../../../_config/constants";
import { useDispatch } from "react-redux";
import { modalActions } from "../../../../../_store/actions/modal.actions";
import ContainerDetails from "../../../../containers/add/list/details";

const List = ({
  data,
  activeTab,
  selectedContainers,
  handleCheckedContainers,
  loadingData,
}) => {
  const dispatch = useDispatch();
  return (
    <div className={styles.wrapper}>
      {loadingData && (
        <div className={styles.loading}>
          <Loading width={50} height={50} />
        </div>
      )}
      {!loadingData &&
        data.map((item, index) => {
          return (
            <div className={styles.listContainer} key={index}>
              <div className={styles.item}>
                <p
                  className={styles.name}
                  title={"Show history"}
                  onClick={() =>
                    dispatch(
                      modalActions.openModal(
                        <ContainerDetails containerId={item._id} />,
                        "",
                        "xlg"
                      )
                    )
                  }
                >
                  {index + 1}. #{item.uniqueContainerId}
                </p>
                <div className={styles.qrWrapper}>
                  <p>{item.name}</p>
                  <QrGenerator
                    id={item._id}
                    uniqueId={item.uniqueContainerId}
                    batchId={item.batchId}
                    name={item.name}
                    size={item.size}
                    material={item.material}
                    volume={item.volume}
                  />
                  <Checkbox
                    customClass="checkbox"
                    checked={selectedContainers.includes(item)}
                    onChange={() => handleCheckedContainers(item)}
                    label=""
                  />
                </div>
              </div>
              <p className={styles.smallerP}>
                {t.common.text_ordered_from}{" "}
                {item.restaurantName
                  ? item.restaurantName
                  : "Unspecified Store"}{" "}
                -{" "}
                {item.orderedAt
                  ? moment(item.orderedAt).format("MM/DD/YYYY")
                  : "Unspecified Date"}
              </p>
              {item.days_to_return && getDaysLeft(item.days_to_return) > 0 && (
                <p className={styles.smallerP}>
                  {getDaysLeft(item.days_to_return)}{" "}
                  {getDaysLeft(item.days_to_return) === 1 ? "Day" : "Days"} to
                  return
                </p>
              )}
              {item.days_to_return && getDaysLeft(item.days_to_return) == 0 && (
                <p className={styles.smallerPRed}>{t.user.text_th_dueDate}</p>
              )}
              {item.days_to_return && getDaysLeft(item.days_to_return) < 0 && (
                <p className={styles.smallerPRed}>
                  {" "}
                  {Math.abs(getDaysLeft(item.days_to_return))}{" "}
                  {getDaysLeft(item.days_to_return) === -1 ? "Day" : "Days"}{" "}
                  late to return
                </p>
              )}
              {!item.days_to_return && (
                <p className={styles.smallerPRed}>
                  {t.user.text_no_return_date}
                </p>
              )}
            </div>
          );
        })}
      {!loadingData && data.length < 1 && (
        <div className={styles.noData}>
          <p>This user has no {activeTab} containers</p>
        </div>
      )}
    </div>
  );
};

export default List;
